import { Capacitor } from '@capacitor/core'
import { App } from '@capacitor/app'

export type NativeBuild = { version: string; build: string } | null

/** Older installed binaries have no App plugin. Never substitute web versions. */
export async function readNativeBuild(): Promise<NativeBuild> {
  if (!Capacitor.isNativePlatform() || !Capacitor.isPluginAvailable('App')) return null
  try {
    const { version, build } = await App.getInfo()
    return version && build ? { version, build } : null
  } catch {
    return null
  }
}
